// extracted by css-extract-rspack-plugin
export default {"container":"src-domain-components-logical-device-actions-logicalDeviceActions-module__container-gAoK6E","kebab":"src-domain-components-logical-device-actions-logicalDeviceActions-module__kebab-IhEtx6","screenShareButton":"src-domain-components-logical-device-actions-logicalDeviceActions-module__screenShareButton-tJEh1u"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"container\":\"src-domain-components-logical-device-actions-logicalDeviceActions-module__container-gAoK6E\",\"kebab\":\"src-domain-components-logical-device-actions-logicalDeviceActions-module__kebab-IhEtx6\",\"screenShareButton\":\"src-domain-components-logical-device-actions-logicalDeviceActions-module__screenShareButton-tJEh1u\"}";
        // 1792611263424
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  